import swal from 'sweetalert2';

const delay = 500;
const removeElement = el => el.parentNode.removeChild(el);

export default function print(el) {
  // Create iframe
  const iframe = document.createElement('iframe');
  iframe.style.border = 'none';
  iframe.style.position = 'absolute';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.style.bottom = '0px';
  iframe.style.left = '0px';

  // Add to body and fill with content
  document.body.appendChild(iframe);

  let doc = (iframe.contentWindow || iframe.contentDocument);
  if (doc.document) doc = doc.document;

  let html = '<html><head>';
  html += '<link rel="stylesheet" href="/css/app.css">';
  html += `</head><body>${el.outerHTML}</body></html>`;

  doc.open();
  doc.write(html);
  doc.close();

  // Remove all "hide for print" elements
  const hidden = doc.getElementsByClassName('hidden-print');
  while (hidden[0]) removeElement(hidden[0]);

  // Actually print the document, after a timeout
  const timeout = setTimeout(() => {
    swal.close();

    const printDocument = iframe.contentWindow || iframe;
    printDocument.focus();
    printDocument.print();

    // Fix for safari print "prevention"
    setTimeout(() => removeElement(iframe), 15 * 1000);
  }, delay);

  // Show "preparing for print" modal
  swal({
    html: 'Drucken wird vorbereitet...',
    animation: false,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonColor: '#db6e6e',
    cancelButtonText: 'Abbrechen',
  }).then(() => {
    clearTimeout(timeout);
    removeElement(iframe);
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/print.js